import { useEffect, useState, useRef } from '@wordpress/element';
import VendorSelect from "./vendor-select";

export default function TestDrive({ classification = '', isClassificationFixed = false, vendorId = null, modelId = null }) {
  const [selectedClassification, setSelectedClassification] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [models, setModels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [postalCode, setPostalCode] = useState('');
  const [acceptMarketing, setAcceptMarketing] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  const [fieldErrorMessages, setFieldErrorMessages] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);


  useEffect(() => {
    if (classification) {
      // get first char from classification to determine the type of the model
      let predefinedClassification = classification.charAt(0).toUpperCase();
      const validClassifications = ['C', 'U', 'Z'];
      if (validClassifications.includes(predefinedClassification)) {
        setSelectedClassification(predefinedClassification);
      }

    }
    loadModels();
  }, [])

  useEffect(() => {
    // Wenn die Klassifikation geändert wird, aber ein Modell ausgewählt ist, das nicht zur neuen Klassifikation passt, dann Auswahl zurücksetzen
    if (selectedClassification !== null && selectedClassification !== '') {
      if (selectedModel && selectedModel.classification.charAt(0).toUpperCase() !== selectedClassification) {
        setSelectedModel(null);
      }
    }
  }, [selectedClassification])

  useEffect(() => {
    if (models.length == 0) return;
    // do something with the models
  }, [models]);

  async function loadModels() {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    let url = `/wp-json/cqvs/v1/models`;
    if (classification) {
      url += `?classification=${encodeURIComponent(classification)}`;
    }

    const response = await fetch(url);

    if (!response.ok) {
      // oups! something went wrong
      setIsLoading(false);
      return;
    }

    let newModels = await response.json();

    setModels(newModels);

    setIsLoading(false);
  }


  const filteredModels = models.filter(model => {
    if (modelId && model.id !== parseInt(modelId)) {
      return false;
    }
    if (selectedClassification && model.classification.charAt(0).toUpperCase() !== selectedClassification) {
      return false;
    }
    return true;
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const clearFieldError = (fieldName) => {
    setFieldErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[fieldName];
      return newErrors;
    });
    setFieldErrorMessages(prev => {
      const newMessages = { ...prev };
      delete newMessages[fieldName];
      return newMessages;
    });
    setValidationErrors([]);
  };

  const validateForm = () => {
    const errors = [];
    const fields = {};
    const messages = {};

    if (!selectedClassification) {
      errors.push('Bitte wähle eine Fahrzeugklasse aus.');
      fields.classification = true;
      messages.classification = 'Bitte wähle eine Fahrzeugklasse aus.';
    }

    if (!firstName || firstName.trim() === '') {
      errors.push('Bitte gib deinen Vornamen ein.');
      fields.firstName = true;
      messages.firstName = 'Bitte gib deinen Vornamen ein.';
    }

    if (!lastName || lastName.trim() === '') {
      errors.push('Bitte gib deinen Nachnamen ein.');
      fields.lastName = true;
      messages.lastName = 'Bitte gib deinen Nachnamen ein.';
    }

    if (!postalCode || postalCode.trim() === '') {
      errors.push('Bitte gib deine Postleitzahl ein.');
      fields.postalCode = true;
      messages.postalCode = 'Bitte gib deine Postleitzahl ein.';
    }

    if (!email || email.trim() === '') {
      errors.push('Bitte gib deine E-Mail-Adresse ein.');
      fields.email = true;
      messages.email = 'Bitte gib deine E-Mail-Adresse ein.';
    } else if (!validateEmail(email)) {
      errors.push('Bitte gib eine gültige E-Mail-Adresse ein.');
      fields.email = true;
      messages.email = 'Bitte gib eine gültige E-Mail-Adresse ein.';
    }

    if (!phone || phone.trim() === '') {
      errors.push('Bitte gib deine Telefonnummer ein.');
      fields.phone = true;
      messages.phone = 'Bitte gib deine Telefonnummer ein.';
    }

    if (!selectedVendor) {
      errors.push('Bitte wähle einen Händler aus.');
      fields.vendor = true;
      messages.vendor = 'Bitte wähle einen Händler aus.';
    }

    setValidationErrors(errors);
    setFieldErrors(fields);
    setFieldErrorMessages(messages);

    return errors.length === 0;
  };

  if (isSubmitted) {
    return (
      <div className="testdrive-success">
        <h2>Vielen Dank für deine Anfrage!</h2>
        <p>Dein ausgewählter Händler wird sich in Kürze bei dir melden.</p>
      </div>
    );
  }

  return (
    <>
      <div className="model-selection cf-form">
        <div className="model-selection-fields">
          <h3>Welches Modell möchtest du Probe fahren?</h3>
          {!isClassificationFixed && (
            <>
              <label htmlFor="classification-select">Fahrzeugklasse *</label>
              <select
                id="classification-select"
                className={fieldErrors.classification ? 'field-error' : ''}
                value={selectedClassification || ''}
                onChange={(e) => {
                  setSelectedClassification(e.target.value);
                  clearFieldError('classification');
                }}
              >
                <option value="">Bitte wählen</option>
                <option value="C">ATV</option>
                <option value="U">UTV</option>
                <option value="Z">Motorrad</option>
              </select>
              {fieldErrorMessages.classification && (
                <div className="field-error-message">{fieldErrorMessages.classification}</div>
              )}
            </>
          )}
          <label htmlFor="model-select">Modell</label>
          <select id="model-select" value={selectedModel ? selectedModel.id : ''} disabled={!selectedClassification} onChange={(e) => {
            const model = models.find(m => m.id === parseInt(e.target.value));
            setSelectedModel(model);
          }}>
            {!selectedClassification && <option value="">Bitte wähle zuerst eine Klasse aus</option>}
            {selectedClassification && isLoading && <option value="">Lade Modelle...</option>}
            {selectedClassification && !isLoading && <option value="">Bitte wählen</option>}
            {filteredModels.map(model => (
              <option key={model.id} value={model.id}>{model.title}</option>
            ))}
          </select>
        </div>
        <div className="model-selection-preview">
          {selectedModel ? (
            <div className="model-preview">
              <img src={selectedModel.featured_image} alt={selectedModel.title} />
              <p>{selectedModel.excerpt}</p>
            </div>
          ) : (
            <div className="model-preview-placeholder">

            </div>
          )}
        </div>
      </div>
      <div className="contact-fields">
        <h3>Deine Kontaktdaten</h3>
        <label htmlFor="title">Anrede</label>
        <select id="title" value={title} onChange={(e) => setTitle(e.target.value)}>
          <option value="">Bitte wählen</option>
          <option value="Herr">Herr</option>
          <option value="Frau">Frau</option>
          <option value="Divers">Divers</option>
        </select>

        <label htmlFor="firstName">Vorname *</label>
        <input
          type="text"
          id="firstName"
          className={fieldErrors.firstName ? 'field-error' : ''}
          value={firstName}
          required
          autoComplete='given-name'
          onChange={(e) => {
            setFirstName(e.target.value);
            clearFieldError('firstName');
          }}
        />
        {fieldErrorMessages.firstName && (
          <div className="field-error-message">{fieldErrorMessages.firstName}</div>
        )}

        <label htmlFor="lastName">Nachname *</label>
        <input
          type="text"
          id="lastName"
          className={fieldErrors.lastName ? 'field-error' : ''}
          value={lastName}
          required
          autoComplete='family-name'
          onChange={(e) => {
            setLastName(e.target.value);
            clearFieldError('lastName');
          }}
        />
        {fieldErrorMessages.lastName && (
          <div className="field-error-message">{fieldErrorMessages.lastName}</div>
        )}

        <label htmlFor="postalCode">Postleitzahl *</label>
        <input
          type="text"
          id="postalCode"
          className={fieldErrors.postalCode ? 'field-error' : ''}
          value={postalCode}
          required
          autoComplete='postal-code'
          onChange={(e) => {
            setPostalCode(e.target.value);
            clearFieldError('postalCode');
          }}
        />
        {fieldErrorMessages.postalCode && (
          <div className="field-error-message">{fieldErrorMessages.postalCode}</div>
        )}

        <label htmlFor="email">E-Mail *</label>
        <input
          type="email"
          id="email"
          className={fieldErrors.email ? 'field-error' : ''}
          value={email}
          required
          autoComplete='email'
          onChange={(e) => {
            setEmail(e.target.value);
            clearFieldError('email');
          }}
        />
        {fieldErrorMessages.email && (
          <div className="field-error-message">{fieldErrorMessages.email}</div>
        )}

        <label htmlFor="phone">Telefonnummer *</label>
        <input
          type="tel"
          id="phone"
          className={fieldErrors.phone ? 'field-error' : ''}
          value={phone}
          required
          autoComplete='tel'
          onChange={(e) => {
            setPhone(e.target.value);
            clearFieldError('phone');
          }}
        />
        {fieldErrorMessages.phone && (
          <div className="field-error-message">{fieldErrorMessages.phone}</div>
        )}
      </div>
      <div className={`vendor-selection ${selectedClassification ? '' : 'vendor-selection-disabled'} ${fieldErrors.vendor ? 'field-error-section' : ''}`}>
        <h3>Bei welchem Händler möchtest du eine Probefahrt machen? *</h3>
        <div className='vendor-search'>
          {selectedClassification ? (
            <VendorSelect
              classification={selectedClassification}
              onVendorSelect={(vendor) => {
                setSelectedVendor(vendor);
                clearFieldError('vendor');
              }}
              preselectedVendorId={vendorId}
              postalCode={postalCode}
            />
          ) : (
            <p>Bitte wähle zuerst eine Klasse aus, um die verfügbaren Händler zu sehen.</p>
          )}
        </div>
      </div>
      {fieldErrorMessages.vendor && (
        <div className="field-error-message">{fieldErrorMessages.vendor}</div>
      )}
      {selectedVendor && (
        <div className="selected-vendor">
          <h4>Ausgewählter Händler:</h4>
          <p>
            <strong>{selectedVendor.title}</strong><br />
            {selectedVendor.street}<br />
            {selectedVendor.zipcode} {selectedVendor.city}
          </p>
        </div>
      )}
      <button className="submit-button button" onClick={() => {
        // Validierung durchführen
        if (!validateForm()) {
          // Scroll zum ersten Fehler
          const firstError = document.querySelector('.field-error, .field-error-section');
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }

        // Formular absenden
        const formData = {
          classification: selectedClassification,
          modelId: selectedModel?.id,
          title,
          firstName,
          lastName,
          email,
          phone,
          postalCode,
          vendorId: selectedVendor?.id,
          acceptMarketing,
        };

        // API Call
        fetch('/wp-json/cqvs/v1/testdrive', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              setIsSubmitted(true);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
              alert('Es ist ein Fehler aufgetreten. Bitte versuche es erneut.');
            }
          })
          .catch(error => {
            console.error('Error:', error);
            alert('Es ist ein Fehler aufgetreten. Bitte versuche es erneut.');
          });
      }}>Probefahrt vereinbaren</button>

      {validationErrors.length > 0 && (
        <div className="validation-errors">
          <h4>Bitte überprüfe deine Eingaben:</h4>
          <ul>
            {validationErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

